import React, { createContext, useState } from 'react'

// Create the context
export const ThemeContext = createContext()

// Create the context provider
export const ThemeProvider = ({ children }) => {
  // Define the initial theme state
  const [theme, setTheme] = useState('dark')
  const [loading, setLoading] = useState(false)

  // Function to toggle the theme
  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark')
  }

  // Provide the theme state and toggle function to child Components
  return <ThemeContext.Provider value={{ theme, toggleTheme, loading, setLoading }}>{children}</ThemeContext.Provider>
}
